import Plotly from 'plotly.js-dist-min';
import * as mapplayer from "../ui-map/map.js";
import * as c from "../common.js";

const MODE_WINDOW = "Window";
const MODE_LABEL = "Label";
let _UIpolarPaneState = {
  startTs: null,
  endTs: null,
  lastStartTs:null,
  lastEndTs:null,
  windowSec: 20 * 60,
  visible: false,
  mode: MODE_WINDOW,
  showDotsOnPolar:false
};

const polarBeginTime = document.getElementById("polarbeginTime");
const polarEndTime = document.getElementById("polarendTime");

export function initListener(divId, handleClickFn) {
  _UIpolarPaneState.divId = divId;
  const plotDiv = document.getElementById(divId);
  plotDiv.on('plotly_click', function(data){
    const point = data.points[0];
    handleClickFn(point.customdata);
  });
}

export function getVisible() {
  return _UIpolarPaneState.visible;
}

export function setButtonEnabled(flag) {
  ctrlPolar.disabled = !flag;
}

export function setVisible(flag) {
  mapplayer.clearTimeWindow();
  _UIpolarPaneState.visible = flag;
  ctrlPolar.classList.toggle('selected', flag);
  document.getElementById("polarWrapper").style.display = flag ? "block" : "none";
  if (flag) {
    setButtonEnabled(true);
    mapplayer.displayTimeWindow(true);
    Plotly.Plots.resize('pb-polar-plot');
    updatePolarPane();
  } else {
    mapplayer.displayTimeWindow(false);
  }
  toggleWindowMode(_UIpolarPaneState.mode == MODE_WINDOW);
}


let _lastVessel = null;
let _lastClickFn = null;
export function updatePolarPane(handleClickFn = _lastClickFn, vessel = _lastVessel) {
  handleClickFn = handleClickFn == null ? _lastClickFn : handleClickFn;
  _lastClickFn = handleClickFn;
  _lastVessel = vessel;
  if (!getVisible())
    return;
  updateTimeWindow();
  if (_UIpolarPaneState.startTs == null) {
    plotPolarMap(null, null, [], 'polarPlot', true, _UIpolarPaneState.showDotsOnPolar, handleClickFn, true);
  } else if (_UIpolarPaneState.forceUpdate || isTimeWindowChanged()) {
    _UIpolarPaneState.forceUpdate = false;
    let endIdx = mapplayer.getTimeIndex(vessel.data, _UIpolarPaneState.endTs);
    if (endIdx < 0)
      endIdx = vessel.data.length - 1;
    else
      endIdx = Math.min(vessel.data.length - 1, endIdx);

    let startIdx = mapplayer.getTimeIndex(vessel.data, _UIpolarPaneState.startTs);
    if (startIdx < 0) {
      startIdx = 0;
      _UIpolarPaneState.startTs = vessel.data[0].t;
    }
    let dataArr = vessel.data.slice(startIdx, endIdx + 1);
    const polar = c.createPolar(dataArr, true);
    plotPolarMap(polar, null, dataArr, 'polarPlot', true, _UIpolarPaneState.showDotsOnPolar, handleClickFn, true);
    const frameTimeStart = dataArr[0].t;
    const frameTimeEnd = dataArr[dataArr.length - 1].t;
    polarBeginTime.textContent = frameTimeStart.format("HH:mm:ss");
    polarEndTime.textContent = frameTimeEnd.format("HH:mm:ss");
    mapplayer.updateTimeWindow(frameTimeStart, frameTimeEnd);
  }
}


const _polarLabelList = document.getElementById('polarLabelList');
function updateTimeWindow() {
  _UIpolarPaneState.lastStartTs = _UIpolarPaneState.startTs;
  _UIpolarPaneState.lastEndTs = _UIpolarPaneState.endTs;
  const playTime = mapplayer.getCurrentPlayTime();
  if (_UIpolarPaneState.mode == MODE_WINDOW) {
    _UIpolarPaneState.endTs = playTime;
    _UIpolarPaneState.startTs = _UIpolarPaneState.endTs.clone().subtract(_UIpolarPaneState.windowSec, 'seconds');
  } 
  /*else if (_UIpolarPaneState.mode == MODE_LABEL) {
    const annotation = c.raceData().info().getAnnotationFor(playTime);
    if (annotation != null) {
      _UIpolarPaneState.endTs = annotation.end_ts;
      _UIpolarPaneState.startTs = annotation.begin_ts;
      _polarLabelList.innerHTML = '';
      for(const a of annotation.labels)
        _polarLabelList.appendChild(createAnnotationLabel(a));
    } else {
      _UIpolarPaneState.endTs = null;
      _UIpolarPaneState.startTs = null;
    }
  }*/
}

function isTimeWindowChanged() {
  return _UIpolarPaneState.lastStartTs != _UIpolarPaneState.startTs || _UIpolarPaneState.lastEndTs != _UIpolarPaneState.endTs;
}

let _maxR = 0;
export function plotPolarMap(polar, polarOverlay, timeFrames, divId, halfPolar, dots, handleClickFn=null, resetMaxR=false) {
  if (resetMaxR) {
    _maxR=0;
  }
  const traces = c.generatePolarTraces(polar);
  const rValues = traces.map(trace => trace.r).flat();
  _maxR = Math.max(_maxR,...rValues);

  if (polarOverlay != null) {
    const overlayTraces = c.generatePolarTraces(polarOverlay);
    overlayTraces.forEach(trace => {
      trace.line = trace.line || {};
      trace.line.dash = 'dot';
      trace.opacity = 0.7;
    });
    const rValues = overlayTraces.map(trace => trace.r).flat();
    _maxR = Math.max(_maxR,...rValues);
    traces.push(...overlayTraces);
  }

  const sector = halfPolar ? [-90, 90] : [0, 360];
  const layout = {
    title: 'Polar Performance Plot',
    // width: 400,         // width in pixels
    // height: 400,        // height in pixels
    polar: {
      sector: sector, // Only show 0° to 180°
      radialaxis: {
        visible: true,
        title: 'Boat Speed (kn)',
        range: [0, _maxR]
      },
      angularaxis: {
        direction: "clockwise",
        rotation: 90, // Put 0° at top
        tickmode: 'linear',
        tick0: 0,
        dtick: 10,
      }
    },
    showlegend: true,
    margin: {
      l: 10,
      r: 10,
      t: 20,
      b: 20
    }
  };
  const config = {
    displayModeBar: false,
    responsive: true
  };

  if (dots && timeFrames != null) {
    const dotTraces = generatePolarTracesFromTimeframes(timeFrames, halfPolar);
    traces.push(...dotTraces);
  }
  Plotly.newPlot(divId, traces, layout, config);
  if (handleClickFn != null) {
    const plotDiv = document.getElementById(divId);
    plotDiv.on('plotly_click', function(data){
      const point = data.points[0];
      handleClickFn(point.customdata);
    }); 
  }
}

export function clearPointHighlight(divId) {
  const plotDiv = document.getElementById(divId);
  const traceIndex = plotDiv.data.findIndex(trace => trace.name === 'Point-Highlight');
  
  if (traceIndex !== -1) {
    Plotly.deleteTraces(divId, traceIndex);
  }
}

export function pointHighlight(divId, angle, bs) {
  const highlightTrace = {
    theta: [angle],
    r: [bs],
    type: 'scatterpolar',
    mode: 'markers',
    marker: {
      color: 'red',
      size: 12,
      symbol: 'circle-open',
      line: { width: 2 }
    },
    name: 'Point-Highlight',
    showlegend: false
  };
  
  Plotly.addTraces(divId, highlightTrace);
}

function generatePolarTracesFromTimeframes(timeframes, halfPolar) {
  const speedBins = {};
  for (const f of timeframes) {
    const spdBin = c.binValueWindSpd(f.tws);
    let b = speedBins[String(spdBin)];
    if (b == undefined) {
      b = [];
      speedBins[String(spdBin)] = b;
    }

    b.push(f);
  }
  const speedBinArr = [];
  Object.keys(speedBins).forEach(b => {
    speedBinArr.push(b);
  });
  const sortedSpdBins = [...speedBinArr].sort((a, b) => parseInt(a) - parseInt(b));
  
  const traces = [];
  sortedSpdBins.forEach(b => {
    const theta = [];
    const r = [];
    const timestamps = [];
    const frames = speedBins[String(b)];
    for (const f of frames) {
      let angle = f.twa;
      if (halfPolar && f.twa > 180)
        angle = (360 - f.twa);
      theta.push(angle);
      r.push(f.bs);
      timestamps.push(f.t);
    }
    
    traces.push({
      type: "scatterpolar",
      mode: "markers",
      name: `TWS ${b} kn`,
      theta: theta,
      r: r,
      customdata: timestamps,
      opacity: 0.4,
      marker: { color: c.getColorForWind(b)}
    });
  });

  return traces;
}


const polarWindowText = document.getElementById("polarWindow");
const ctrlPolar = document.getElementById("ctrlTogglePolar");
// const polarWindowButton = document.getElementById("polarWindowMode");
// const polarLabelButton = document.getElementById("polarLabelMode");

// polarWindowButton.addEventListener("focus", (event) => {
//   toggleWindowMode(true);
// });

// polarLabelButton.addEventListener("focus", (event) => {
//   toggleWindowMode(false);
// });

function toggleWindowMode(flag) {
  // polarWindowButton.disabled = flag;
  polarWindowText.disabled = !flag;
  // polarLabelButton.disabled = !flag;
  _UIpolarPaneState.mode = flag ? MODE_WINDOW : MODE_LABEL;
}

["input", "change"].forEach(e => {
  polarWindowText.addEventListener(e, (event) => {
    let window = event.target.value;
    window = parseInt(window.replace(/\w\W/g, ""));
    _UIpolarPaneState.windowSec = window == NaN ? _UIpolarPaneState.windowSec : window * 60;
    mapplayer.updateTimeWindow(_UIpolarPaneState.startTs, _UIpolarPaneState.endTs);
  })
});

polarWindowText.addEventListener("focus", (event) => {
  mapplayer.updateTimeWindow(_UIpolarPaneState.startTs, _UIpolarPaneState.endTs);
});

polarWindowText.addEventListener("blur", (event) => {
  mapplayer.clearTimeWindow();
});

ctrlPolar.addEventListener("click", (event) => {
  setVisible(!getVisible());
});


function createAnnotationLabel(labelVal) {
  let l = document.createElement('div');
  l.className = 'polar-annotation-label-display';
  l.innerHTML = labelVal;
  l.style.display = labelVal == "" ? "none":"flex";
  return l;
}

document.getElementById('polarDotsToggle').addEventListener("click", (e) => {
  _UIpolarPaneState.showDotsOnPolar = !_UIpolarPaneState.showDotsOnPolar;
  _UIpolarPaneState.forceUpdate=true;
  updatePolarPane();
});


export function plotPolarMapOverlay(polar1, polar2, divId, halfPolar) {
    // Generate traces for both polars
    const traces1 = c.generatePolarTraces(polar1);
    const traces2 = c.generatePolarTraces(polar2);

    // Style traces2 with dotted lines and different color opacity
    traces2.forEach(trace => {
        trace.line = trace.line || {};
        trace.line.dash = 'dot';
        trace.opacity = 0.7;
        trace.name = (trace.name || '') + ' (overlay)';
    });

    // Find max R for axis scaling
    const rValues = [...traces1, ...traces2].map(trace => trace.r).flat();
    const maxR = Math.max(0, ...rValues);

    const sector = halfPolar ? [-90, 90] : [0, 360];
    const layout = {
        title: 'Polar Overlay Plot',
        polar: {
            sector: sector,
            radialaxis: {
                visible: true,
                title: 'Boat Speed (kn)',
                range: [0, maxR]
            },
            angularaxis: {
                direction: "clockwise",
                rotation: 90,
                tickmode: 'linear',
                tick0: 0,
                dtick: 10,
            }
        },
        showlegend: true,
        margin: {
            l: 10,
            r: 10,
            t: 20,
            b: 20
        }
    };
    const config = {
        displayModeBar: false,
        responsive: true
    };

    let allTraces = [...traces1, ...traces2];

    Plotly.newPlot(divId, allTraces, layout, config);
  }